// extracted by mini-css-extract-plugin
export var avatarContainer = "_50-0";
export var avatarTypingWave = "_50-i";
export var gray = "_50-f";
export var green = "_50-c";
export var icon = "_50-9";
export var image = "_50-1";
export var lg = "_50-6";
export var md = "_50-5";
export var presenceDot = "_50-b";
export var red = "_50-d";
export var sm = "_50-4";
export var status = "_50-a";
export var typingDot = "_50-h";
export var typingPill = "_50-g";
export var xl = "_50-7";
export var xs = "_50-3";
export var xxl = "_50-8";
export var xxs = "_50-2";
export var yellow = "_50-e";